// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./styles/vendor.scss
// module id = 12
// module chunks = 0